import magicStyles from './message.magic.css.js';
import MessageComponent from './message.js';
import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';

const __vue_script__ = MessageComponent;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "magic-ui-box",
    {
      staticClass: "box",
      attrs: { "add-bottom-margin": "", elevation: "3", part: "box" }
    },
    [
      _vm.shouldShowMessageImage
        ? _c("div", { staticClass: "header", attrs: { part: "header" } }, [
            _c(
              "picture",
              { staticClass: "picture", attrs: { part: "picture" } },
              [
                _c("source", {
                  attrs: { type: "image/avif", srcset: _vm.avifSrcset }
                }),
                _vm._v(" "),
                _c("source", {
                  attrs: { type: "image/webp", srcset: _vm.webpSrcset }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "image",
                  attrs: {
                    part: "image",
                    loading: "lazy",
                    src: _vm.src,
                    alt: _vm.message.image
                  }
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper", attrs: { part: "wrapper" } },
        [
          _c(
            "div",
            {
              staticClass: "heading",
              class: { "heading--internal": !_vm.summary },
              attrs: {
                part: _vm.$p("heading", { "heading--internal": !_vm.summary })
              }
            },
            [
              _vm.summary
                ? _c("magic-ui-icon", {
                    staticClass: "icon",
                    attrs: { name: "email", part: "icon" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.sentDate
                ? _c("magic-ui-text", {
                    staticClass: "date",
                    attrs: { part: "date", content: _vm.sentDate }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("magic-ui-text", {
            staticClass: "subject",
            class: { "subject--internal": !_vm.summary },
            attrs: {
              tag: "h3",
              part: _vm.$p("subject", { "subject--internal": !_vm.summary }),
              content: _vm.messageSubject
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.summary
        ? _c("magic-ui-text", {
            staticClass: "body",
            attrs: { "is-markdown": "", part: "body", content: _vm.messageBody }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.summary && _vm.messageTNC
        ? _c(
            "magic-ui-accordion",
            {
              staticClass: "accordion",
              attrs: { "no-animation": "", part: "accordion" }
            },
            [
              _c("div", {
                attrs: { slot: "toggle" },
                domProps: { innerHTML: _vm._s(_vm.$t("message.tnc.title")) },
                slot: "toggle"
              }),
              _vm._v(" "),
              _c("magic-ui-text", {
                staticClass: "content",
                attrs: {
                  slot: "content",
                  part: "content",
                  content: _vm.messageTNC
                },
                slot: "content"
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.summary
        ? _c(
            "div",
            {
              staticClass: "action action--half",
              attrs: { part: "action action--half" }
            },
            [
              _c("magic-ui-button", {
                staticClass: "button button--half",
                attrs: {
                  hollow: "",
                  wide: "",
                  variant: "error",
                  part: "button button--half",
                  disabled: _vm.isArchiving,
                  loading: _vm.isArchiving
                },
                domProps: {
                  innerHTML: _vm._s(_vm.$t("message.delete.button"))
                },
                on: {
                  click: function($event) {
                    return _vm.archive()
                  }
                }
              }),
              _vm._v(" "),
              _c("magic-ui-link", {
                staticClass: "link link--half",
                attrs: {
                  button: "",
                  wide: "",
                  variant: "primary",
                  part: "link link--half",
                  hollow: _vm.isRead
                },
                domProps: {
                  to: {
                    route: _vm.RoutablePage.MESSAGE,
                    params: { messageId: _vm.message.id }
                  },
                  innerHTML: _vm._s(_vm.readButtonText)
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.summary
        ? _c(
            "div",
            { staticClass: "action", attrs: { part: "action" } },
            [
              _vm.isGamingAlert() && _vm.isNew
                ? _c("magic-ui-button", {
                    staticClass: "button button--acknowledge",
                    attrs: {
                      wide: "",
                      variant: "primary",
                      part: "button button--acknowledge"
                    },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("message.responsible-gaming-alert.acknowledge")
                      )
                    },
                    on: {
                      click: function($event) {
                        return _vm.acknowledge()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.messageLink && _vm.messageURL
                ? _c("magic-ui-button", {
                    staticClass: "button",
                    attrs: {
                      wide: "",
                      "button-tag": "a",
                      variant: "primary",
                      part: "button",
                      href: _vm.messageURL
                    },
                    domProps: { innerHTML: _vm._s(_vm.messageLink) },
                    on: {
                      click: function($event) {
                        return _vm.ctaClicked("primary")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.messageLink2 && _vm.messageURL2
                ? _c("magic-ui-link", {
                    staticClass: "link link--secondary",
                    attrs: {
                      part: "link link--secondary",
                      href: _vm.messageURL2
                    },
                    domProps: { innerHTML: _vm._s(_vm.messageLink2) },
                    on: {
                      click: function($event) {
                        return _vm.ctaClicked("secondary")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideBacklink
                ? _c(
                    "magic-ui-link",
                    {
                      staticClass: "link",
                      attrs: { part: "link", to: _vm.RoutablePage.MESSAGES }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "link-inner",
                          attrs: { part: "link-inner" }
                        },
                        [
                          _c("magic-ui-icon", {
                            staticClass: "icon icon--link",
                            attrs: { name: "email", part: "icon icon--link" }
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("message.back")) +
                              "\n            "
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-a26fd2de_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-a26fd2de";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
